/**
 * API configuration for backend services
 *
 * These URLs can be overridden via environment variables:
 * - REACT_APP_QUESTIONNAIRE_API_URL (for questionnaire services)
 * - REACT_APP_XAUTH_API_URL (for xAuth service)
 * - REACT_APP_PROFILE_API_URL (for profile service)
 *
 * Note: In Create React App, environment variables must be prefixed with REACT_APP_
 * to be available in the browser at build time.
 *
 * The questionnaire API uses a relative path that will be proxied by nginx
 * to avoid CORS issues. In development, you can override with a direct URL.
 */

export const API_CONFIG = {
    /**
     * Base URL for questionnaire-related API endpoints
     * Uses nginx proxy path to avoid CORS issues in production
     * Can be overridden with REACT_APP_QUESTIONNAIRE_API_URL environment variable
     */
    QUESTIONNAIRE_API_URL: process.env.REACT_APP_QUESTIONNAIRE_API_URL || '/api/questionnaire',

    /**
     * Base URL for xAuth API endpoints
     * Uses proxy path to avoid CORS issues (proxied to https://api.koala.primbs.dev/api/xauth/v0)
     * Can be overridden with REACT_APP_XAUTH_API_URL environment variable
     */
    XAUTH_API_URL: process.env.REACT_APP_XAUTH_API_URL || '/api/xauth',

    /**
     * Base URL for profile API endpoints
     * Uses proxy path to avoid CORS issues (proxied to https://api.koala.primbs.dev/api/profile/v0)
     * Can be overridden with REACT_APP_PROFILE_API_URL environment variable
     */
    PROFILE_API_URL: process.env.REACT_APP_PROFILE_API_URL || '/api/profile',
};
